import Pikaday from 'pikaday';

export default class GardesAstreintes {
  constructor() {
    // Template Gardes et asteintes
    this.select = document.querySelector('section.content .filters select');
    this.printBtn = document.querySelector('section.content .filters .download');

    const initialMonth = document.querySelector('section.content .filters select').children[0].value;
    this.manageRows(initialMonth);
    this.selectEvents();
    this.printPage();
    this.showCalendar();
    this.orderSpecialites();
  }

  selectEvents() {
    if (this.select) {
      this.select.addEventListener('change', () => {
        this.manageRows(this.select.value);
        this.printBtnContent(this.select.value);
      });
    }
  }

  manageRows(id) {
    const table = document.querySelector('section.content .tableau');
    const rows = document.querySelectorAll('section.content .tableau .row');

    if (id === 'all') {
      table.classList.remove('filtered');
      rows.forEach((row) => {
        row.classList.remove('visible');
      });
    } else {
      table.classList.add('filtered');
      rows.forEach((row) => {
        if (row.dataset.time === id) {
          row.classList.add('visible');
        } else {
          row.classList.remove('visible');
        }
      });
    }
  }

  printPage() {
    if (this.printBtn) {
      this.printBtn.addEventListener('click', () => {
        const $url = `http://intranet.pasteur/gardes/imprimePlanningMensuel.do?specialiteId=0&mois=${this.select.value}`;
        window.open($url, '_blank');
      });
    }
  }

  printBtnContent(value) {
    if (value === 'all') {
      this.printBtn.querySelector('span').textContent = 'Télécharger tous les plannings';
      this.printBtn.classList.add('hidden');
    } else {
      const mois = this.select.querySelector(`[value="${value}"]`).dataset.content;

      if (this.select.querySelector(`[value="${value}"]`).dataset.content === 'Avril' || this.select.querySelector(`[value="${value}"]`).dataset.content === 'Août' || this.select.querySelector(`[value="${value}"]`).dataset.content === 'Octobre') {
        this.printBtn.querySelector('span').textContent = `Télécharger les plannings d'${mois}`;
      } else {
        this.printBtn.querySelector('span').textContent = `Télécharger les plannings de ${mois}`;
      }
      this.printBtn.classList.remove('hidden');
    }
  }

  showCalendar() {
    const calendarBtn = document.querySelector('section.content .filters .month');
    if (calendarBtn) {
      new Pikaday({
        field: calendarBtn,
        firstDay: 1,
        i18n: {
          "prev": "Précédent",
          "next": "Suivant",
          "previousMonth": "",
          "nextMonth": "",
          "months": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
          "weekdays": ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
          "weekdaysShort": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"]
        },
        onSelect: function selectRange() {
          const year = this.getMoment().format('YYYY');
          const month = this.getMoment().format('MM');
          const day = this.getMoment().format('DD');
          const $url = `http://intranet.pasteur/gardes/imprimeCahierGardes.do?y=${year}&m=${month}&d=${day}`;
          window.open($url, '_blank');
        },
      });
    }
  }

  orderSpecialites() {
    const orderingBtns = document.querySelector('section.content .tableau .head div .ordering');
    if (orderingBtns) {
      orderingBtns.querySelector('.asc').addEventListener('click', () => {
        this.sortAsc();
      });

      orderingBtns.querySelector('.desc').addEventListener('click', () => {
        this.sortDesc();
      });
    }
  }

  sortAsc() {
    const tableContent = document.querySelector('section.content .tableau .content');
    if (tableContent) {
      const itemsArray = Array.prototype.slice.call(tableContent.children);
      itemsArray.sort((a, b) => {
        if (a.querySelector('.label').innerText < b.querySelector('.label').innerText) return -1;
        if (a.querySelector('.label').innerText > b.querySelector('.label').innerText) return 1;
        return 0;
      });

      itemsArray.forEach((item) => {
        tableContent.appendChild(item);
      });
    }
  }

  sortDesc() {
    const tableContent = document.querySelector('section.content .tableau .content');
    if (tableContent) {
      const itemsArray = Array.prototype.slice.call(tableContent.children);
      itemsArray.sort((a, b) => {
        if (a.querySelector('.label').innerText > b.querySelector('.label').innerText) return -1;
        if (a.querySelector('.label').innerText < b.querySelector('.label').innerText) return 1;
        return 0;
      });

      itemsArray.forEach((item) => {
        tableContent.appendChild(item);
      });
    }
  }
}